import type { AreaCatalog } from '../area';
import type { values as en } from '../en/values';

export const values = {
  'values.person.words': '{name}',
  'values.group.words': 'Gruppe {name}',
  'values.item.words.plain': '{title}',
  'values.item.words.warning': '{title}, Warnung',
  'values.item.words.critical': '{title}, kritisch',
  'values.item.words.done': '{title}, Fertig',
  'values.item.words.cancelled': '{title}, Abgebrochen',
  'values.item.hidden': 'Nicht sichtbar',
  'values.item.hiddenWords.plain': '{hidden}',
  'values.item.hiddenWords.cancelled': '{hidden}, Abgebrochen',
  'values.item.stubWords.plain': '{title}, kein Zugriff',
  'values.item.stubWords.cancelled': '{title}, kein Zugriff, Abgebrochen',
  'values.item.stubWords.done': '{title}, kein Zugriff, Fertig',
  'values.item.stubWords.endsAfter': '{title}, kein Zugriff, endet nach dem Ende dieser Aufgabe',
  'values.date.words': '{date}',
  'values.date.pastDue': '{date}, überfällig',
  'values.date.week': 'KW {week}',
  'values.date.weekOfYear': 'KW {week} {year}',
  'values.date.quarter': 'Q{quarter}',
  'values.date.quarterOfYear': 'Q{quarter} {year}',
  'values.date.range': '{from} – {to}',
  'values.stage.words': 'Phase {stage}',
  'values.tag.words': 'Tag {path}',
  'values.health.words.critical': '{state}, kritisch',
  'values.health.words.warning': '{state}, Warnung',
  'values.health.words.notice': '{state}, Hinweis',
  'values.health.words.info': '{state}',
  'values.health.state.disputed': 'Abnahme verweigert',
  'values.health.state.blocked': 'Blockiert',
  'values.health.state.stale': 'Stockt',
  'values.health.state.unrequested': 'Verwaist',
  'values.health.state.watch': 'Im Blick',
  'values.health.state.atRisk': 'Gefährdet',
  'values.health.state.delayed': 'Verzögert',
  'values.health.state.blockedUpstream': 'Abhängigkeit blockiert',
  'values.health.state.offTrack': 'Vom Kurs ab',
  'values.lifecycle.words': '{state}',
  'values.lifecycle.withAxis': '{axis} {state}',
  'values.glyph.active': 'Aktiv: als in Arbeit markiert.',
  'values.glyph.idle': 'Ruhend: gerade arbeitet niemand daran.',
  'values.glyph.review': 'Review: die Arbeit ist fertig und wartet auf ihre Review.',
  'values.glyph.done': 'Fertig: die Arbeit ist erledigt.',
  'values.glyph.cancelled': 'Abgebrochen: beendet, ohne dass die Arbeit getan wurde.',
  'values.glyph.clean': 'Nichts markiert.',
  'values.glyph.flagged': 'Markiert: ein Zustand verdient einen Blick.',
  'values.glyph.critical': 'Kritisch: ein Zustand braucht jetzt Aufmerksamkeit.',
  'values.number.words': '{value}',
  'values.quoted': '„{text}“',
  'values.change.changed': 'vorher {from}, jetzt {to}',
  'values.change.added': '{value} hinzugefügt',
  'values.change.removed': '{value} entfernt',
  'values.stance.contain': '{name}: nicht betroffen',
} as const satisfies AreaCatalog<typeof en>;
